module.exports = __webpack_public_path__ + "static/media/ArduinoDayLogo.d1b43df6.svg";